import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStarLines: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStarLines"><Path d="M9.5 15.5L4.5 20.5M7.5 10.5L2.5 15.5M16.5 15.5L11.5 20.5M15.5 1.5L17.6395 5.05518L21.6819 5.99139L18.9618 9.12482L19.3206 13.2586L15.5 11.64L11.6794 13.2586L12.0382 9.12482L9.31813 5.99139L13.3605 5.05518L15.5 1.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStarLines;
